<template>
  <div class="alert" :class="{'success': success, 'error': error}"><slot/></div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<style lang="scss" scoped>

strong {
  font-weight: 600;
}
.alert {

  padding: 20px;
  margin-bottom: 20px;
  font-weight: 300;

  &.success {
    $color: #2ecc71;
    background: $color;
    color: darken($color, 20%)
  }
  &.error {
    $color: #eb2136;
    background: $color;
    color: darken($color, 20%)
  }
}
</style>
